(function () {
// module for fixing the duplicate footer in employees view
function $67fe62bba4f72176$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}


function $c8ad65b53af16c0f$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $ab39208b9689224f$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $78e9a368a6679d06$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $f3b0595b21378388$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $78e9a368a6679d06$export$79e617b1955a2616)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $78e9a368a6679d06$export$79e617b1955a2616)(o, minLen);
}


function $4760191c6ef4f460$export$fdf2a89c76341bbf(arr, i) {
    return (0, $67fe62bba4f72176$export$e6256bf45c68d561)(arr) || (0, $c8ad65b53af16c0f$export$2fd15edff6687200)(arr, i) || (0, $f3b0595b21378388$export$a5be06335b3a083c)(arr, i) || (0, $ab39208b9689224f$export$60dbc22abd7da546)();
}


function $06898cbeade2d0f6$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $dad6eba28b45ba70$export$c2c98ac76e997b63(o, p) {
    $dad6eba28b45ba70$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $dad6eba28b45ba70$export$c2c98ac76e997b63(o, p);
}


function $9b70c077c4875d85$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $dad6eba28b45ba70$export$c2c98ac76e997b63)(subClass, superClass);
}


function $c56267624d405c26$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}



function $94562e2bb2932949$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $c56267624d405c26$export$685354647fba1516)()) $94562e2bb2932949$export$2d841144c5f8c4ab = Reflect.construct;
    else $94562e2bb2932949$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $dad6eba28b45ba70$export$c2c98ac76e997b63)(instance, Class.prototype);
        return instance;
    };
    return $94562e2bb2932949$export$2d841144c5f8c4ab.apply(null, arguments);
}


function $f7e26d21e004e519$export$f09211a7d3c496a1(o) {
    $f7e26d21e004e519$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f7e26d21e004e519$export$f09211a7d3c496a1(o);
}


function $5176dbfdc308a7c2$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}



function $9ca5279ec86d239d$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $9ca5279ec86d239d$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $5176dbfdc308a7c2$export$514eda94019f4334)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $94562e2bb2932949$export$2d841144c5f8c4ab)(Class, arguments, (0, $f7e26d21e004e519$export$f09211a7d3c496a1)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $dad6eba28b45ba70$export$c2c98ac76e997b63)(Wrapper, Class);
    };
    return $9ca5279ec86d239d$export$2466d533fda16e33(Class);
}




function $65e015b47439fafe$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $b108fb4996d9c2b1$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


function $69790436dd43d4a5$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $b108fb4996d9c2b1$export$5f0017c582d45a2d)(call) === "object" || typeof call === "function")) return call;
    return (0, $65e015b47439fafe$export$f3b8ed2e4a5d10b8)(self);
}


function $9fc7b79178155e4a$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $c56267624d405c26$export$685354647fba1516)();
    return function _createSuperInternal() {
        var Super = (0, $f7e26d21e004e519$export$f09211a7d3c496a1)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $f7e26d21e004e519$export$f09211a7d3c496a1)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $69790436dd43d4a5$export$ef97c660ca164e52)(this, result);
    };
}



var $f2367938ccf27490$var$AnimationError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $9b70c077c4875d85$export$7e4530ad35d3bb8)(AnimationError, Error1);
    var _super = (0, $9fc7b79178155e4a$export$8dd05c13f5255580)(AnimationError);
    function AnimationError(componentName) {
        (0, $06898cbeade2d0f6$export$2996f80ef42b8419)(this, AnimationError);
        var _this;
        _this = _super.call(this, "Could not load [".concat(componentName, "]"));
        _this.name = "AnimationError";
        return _this;
    }
    return AnimationError;
}((0, $9ca5279ec86d239d$export$2466d533fda16e33)(Error));
var $f2367938ccf27490$export$d199d7650c6599db = function() {
    var img = (0, $37cee55efb58cc92$export$2fa187e846a241c4)(".homepage__media__container > img");
    var video = (0, $37cee55efb58cc92$export$2fa187e846a241c4)(".homepage__media__container > video");
    if (!img && !video) return;
    if (img) {
        // wait for the image to load before starting animation
        var image = new Image();
        image.addEventListener("load", function() {
            img.classList.add("loaded");
        });
        image.src = img.src;
    } else {
        video.controls = false;
        video.autoplay = true;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.load();
        video.addEventListener("loadeddata", function() {
            video.classList.add("loaded");
        });
    }
};
var $f2367938ccf27490$export$b3863211bcd5504f = function(show) {
    var menuContainer = (0, $37cee55efb58cc92$export$2fa187e846a241c4)(".menu__wrapper");
    if (!menuContainer) throw $f2367938ccf27490$var$AnimationError("Menu");
    var menuTexts = (0, $37cee55efb58cc92$export$dcd0d083aa86c355)(".menu__item-top-row > a");
    if (menuTexts.length == 0) throw $f2367938ccf27490$var$AnimationError("Menu items");
    $f2367938ccf27490$export$7753da072bcbb0ad(menuTexts, 100, show);
};
var $f2367938ccf27490$export$492d75ffd1fda340 = function() {
    var containers = (0, $37cee55efb58cc92$export$dcd0d083aa86c355)(".hero");
    containers.forEach(function(c) {
        return $f2367938ccf27490$var$componentAnimation({
            container: c,
            triggerClass: "loaded",
            elementSelectors: [
                ".hero__image",
                ".hero__header",
                ".hero__body",
                ".hero__label"
            ]
        });
    });
};
var $f2367938ccf27490$export$c6c6885902b1b350 = function() {
    var animate = function() {
        var toggleELement = (0, $37cee55efb58cc92$export$2fa187e846a241c4)(".exposed-filters__toggle");
        if (!toggleELement) return;
        var commonParent = (0, $37cee55efb58cc92$export$2fa187e846a241c4)(".exposed-filters");
        var optionContainer = (0, $37cee55efb58cc92$export$2fa187e846a241c4)(".exposed-filters--second-part");
        var options = (0, $37cee55efb58cc92$export$dcd0d083aa86c355)(".filter-option", optionContainer);
        // use onclick instead of adding listener to prevent double event addition
        toggleELement.onclick = function() {
            commonParent.classList.toggle("expanded");
            optionContainer.style.maxHeight = commonParent.classList.contains("expanded") ? optionContainer.scrollHeight + "px" : null;
        };
        $f2367938ccf27490$export$7753da072bcbb0ad(options, 100, 100);
    };
    // observer changes in body to detect filtering and re-rendering of node
    var observer = new MutationObserver(animate);
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    animate();
};
var $f2367938ccf27490$export$6fd29a9eb3d798d5 = function() {
    var animate = function() {
        var employees = (0, $37cee55efb58cc92$export$dcd0d083aa86c355)(".employee");
        var clients = (0, $37cee55efb58cc92$export$dcd0d083aa86c355)(".client");
        var container = (0, $37cee55efb58cc92$export$2fa187e846a241c4)(".list__grid");
        container === null || container === void 0 ? void 0 : container.classList.add("loaded");
        $f2367938ccf27490$export$7753da072bcbb0ad(employees, 100);
        $f2367938ccf27490$export$7753da072bcbb0ad(clients, 100);
    };
    // observer changes in body to detect filtering and re-rendering of node
    var observer = new MutationObserver(animate);
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    animate();
};
var $f2367938ccf27490$export$bde91a748e119f87 = function() {
    var paragraphs = (0, $37cee55efb58cc92$export$dcd0d083aa86c355)(".advice");
    if (paragraphs.length === 0) return;
    // observe each advice paragraph to fade it in on scroll
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) $f2367938ccf27490$var$componentAnimation({
                container: entry.target,
                triggerClass: "loaded",
                elementSelectors: [
                    ".advice__number",
                    ".advice__quote",
                    ".advice__label",
                    ".advice__author"
                ]
            }, 300, 100);
        });
    }, {
        threshold: 0.4
    });
    paragraphs.forEach(function(p) {
        return observer.observe(p);
    });
};
var $f2367938ccf27490$export$a1efd09c4bc91710 = function() {
    (0, $37cee55efb58cc92$export$dcd0d083aa86c355)(".big-header").forEach(function(header) {
        return header.classList.add("loaded");
    });
};
function $f2367938ccf27490$var$componentAnimation(param, delay, baseDelay, show) {
    var container = param.container, triggerClass = param.triggerClass, elementSelectors = param.elementSelectors;
    var selectParent = container // default parent for querySelector() function
    ;
    // if container is given as string selector (meaning there is only one per page)
    if (typeof container === "string") {
        container = (0, $37cee55efb58cc92$export$2fa187e846a241c4)(container) // set container to object from given selector
        ;
        selectParent = document // set default parent to document
        ;
    }
    container === null || container === void 0 ? void 0 : container.classList.add(triggerClass) // add class to trigger css transitions
    ;
    $f2367938ccf27490$export$7753da072bcbb0ad(elementSelectors.map(function(el) {
        return (0, $37cee55efb58cc92$export$2fa187e846a241c4)(el, selectParent);
    }), delay, baseDelay, show);
}
var $f2367938ccf27490$export$af52c964fce46aba = function(parent, show) {
    var submenuList = (0, $37cee55efb58cc92$export$2fa187e846a241c4)(".submenu__items", parent);
    submenuList.style.maxHeight = show ? submenuList.scrollHeight + "px" : null // set the height needed for list's items
    ;
    var submenuTexts = (0, $37cee55efb58cc92$export$dcd0d083aa86c355)(".menu__item > a", submenuList);
    if (submenuTexts.length == 0) throw $f2367938ccf27490$var$AnimationError("Submenu items");
    $f2367938ccf27490$export$7753da072bcbb0ad(submenuTexts, 100, show);
};
function $f2367938ccf27490$export$7753da072bcbb0ad(elements) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 300, baseDelay = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, show = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    elements.forEach(function(el, i) {
        el === null || el === void 0 ? void 0 : el.style.transitionDelay = show ? "".concat(i * delay + baseDelay, "ms") : null;
    });
}
function $f2367938ccf27490$export$292af6cf5856552d(hoverElement, targetElement, delays) {
    if (typeof hoverElement !== "object") hoverElement = (0, $37cee55efb58cc92$export$2fa187e846a241c4)(hoverElement);
    if (typeof targetElement !== "object") targetElement = (0, $37cee55efb58cc92$export$2fa187e846a241c4)(targetElement);
    if (!targetElement || !hoverElement) return;
    hoverElement.addEventListener("mouseover", function() {
        targetElement.style.transitionDelay = null;
    });
    hoverElement.addEventListener("mouseout", function() {
        targetElement.style.transitionDelay = delays;
    });
}


var $37cee55efb58cc92$export$2fa187e846a241c4 = function(selector) {
    var parent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document;
    return parent.querySelector(selector);
};
var $37cee55efb58cc92$export$dcd0d083aa86c355 = function(selector) {
    var parent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document;
    return Array.from(parent.querySelectorAll(selector));
};
var $37cee55efb58cc92$var$clamp = function(val, min, max) {
    return val > max ? max : val < min ? min : val;
};
var $37cee55efb58cc92$export$915f94afd7d29d3d = function() {
    var blocks = $37cee55efb58cc92$export$dcd0d083aa86c355(".colored-text-block");
    blocks.forEach(function(block) {
        var contentHeight = block.scrollHeight;
        if (contentHeight <= 241) return; // 241 is the height of block with 4 lines of text
        block.classList.add("expandable");
        var opener = $37cee55efb58cc92$export$2fa187e846a241c4(".colored-text-block__top--expand", block);
        opener.addEventListener("click", function() {
            block.classList.toggle("expanded");
            if (!block.classList.contains("expanded")) {
                block.style.maxHeight = "240px";
                return;
            }
            block.style.maxHeight = "".concat(contentHeight, "px");
        });
    });
};
var $37cee55efb58cc92$export$b60d31b5254359b3 = function() {
    var logoContainer = $37cee55efb58cc92$export$2fa187e846a241c4(".menu__logo-container");
    var currentLang = document.documentElement.lang;
    logoContainer.href = "/" + (currentLang === "da" ? "" : currentLang);
};
var $37cee55efb58cc92$export$703579326708f7bb = function() {
    var lists = $37cee55efb58cc92$export$dcd0d083aa86c355(".plain__content");
    lists.forEach(function(list) {
        var stickyDetect = $37cee55efb58cc92$export$2fa187e846a241c4(".plain__sticky-detect", list);
        var anchors = $37cee55efb58cc92$export$2fa187e846a241c4(".plain__list", list);
        var observer = new IntersectionObserver(function(param) {
            var _param = (0, $4760191c6ef4f460$export$fdf2a89c76341bbf)(param, 1), e = _param[0];
            anchors.classList.toggle("sticked", e.intersectionRatio < 1);
        }, {
            threshold: [
                0,
                1
            ]
        });
        observer.observe(stickyDetect);
    });
};
var $37cee55efb58cc92$export$4c747dfc877cb40f = function() {
    var cards = $37cee55efb58cc92$export$dcd0d083aa86c355(".christmas-card");
    var modalBox = $37cee55efb58cc92$export$2fa187e846a241c4("#modal-teleport");
    cards.forEach(function(card) {
        var opener = $37cee55efb58cc92$export$2fa187e846a241c4(".christmas-card--open", card) // image element in timeline
        ;
        opener.addEventListener("click", function() {
            // move popup content to modal box
            var popup = $37cee55efb58cc92$export$2fa187e846a241c4(".christmas-card-popup", card);
            modalBox.innerHTML = popup.outerHTML;
            var activePage = -1 // -1 = front image, 0 = first page, 1 = second page, etc.
            ;
            var pages = $37cee55efb58cc92$export$dcd0d083aa86c355(".christmas-card-popup__pages", modalBox) // pages container
            ;
            var arrows = $37cee55efb58cc92$export$dcd0d083aa86c355(".christmas-card-popup__arrows > button", modalBox) // arrow buttons
            ;
            var image = $37cee55efb58cc92$export$2fa187e846a241c4(".christmas-card-popup__image", modalBox) // front image
            ;
            var close = $37cee55efb58cc92$export$2fa187e846a241c4(".christmas-card-popup--close", modalBox);
            var handleArrows = function(directionData) {
                var // hide previous page and show new page
                _pages_activePage, _pages_activePage1;
                // calculate new index based on direction
                var direction = directionData === "left" ? -1 : 1;
                var newIndex = $37cee55efb58cc92$var$clamp(activePage + direction, -1, pages.length - 1);
                (_pages_activePage = pages[activePage]) === null || _pages_activePage === void 0 ? void 0 : _pages_activePage.classList.remove("active");
                activePage = newIndex;
                (_pages_activePage1 = pages[activePage]) === null || _pages_activePage1 === void 0 ? void 0 : _pages_activePage1.classList.add("active");
                // disable arrows if first or last page is active
                arrows[0].disabled = activePage === -1;
                arrows[1].disabled = activePage === pages.length - 1;
                // show card image if index is negative
                if (activePage === -1) image.classList.remove("hidden");
                // hide card image if first page is active
                if (activePage === 0) image.classList.add("hidden");
            };
            arrows.forEach(function(arrow) {
                arrows[1].disabled = activePage === pages.length - 1 // disable right arrow if there are
                ;
                arrow.addEventListener("click", function() {
                    return handleArrows(arrow.dataset.direction);
                });
            });
            // disable scroll and show modal
            document.documentElement.classList.add("no-scroll");
            modalBox.classList.add("active");
            var handleButton = function(e) {
                switch(e.key){
                    case "Escape":
                        closePopup();
                        break;
                    case "ArrowLeft":
                        handleArrows("left");
                        break;
                    case "ArrowRight":
                        handleArrows("right");
                        break;
                }
            };
            var closePopup = function() {
                modalBox.classList.remove("active");
                modalBox.innerHTML = "";
                document.documentElement.classList.remove("no-scroll");
                window.removeEventListener("keyup", handleButton);
            };
            // close popup on [x] click
            close.addEventListener("click", closePopup);
            // allow closing popup with escape and navigation with arrows
            window.addEventListener("keyup", handleButton);
        });
    });
};
var $37cee55efb58cc92$export$3bc0b7c14dc62adc = function() {
    if (!$37cee55efb58cc92$export$2fa187e846a241c4(".lr-timeline")) return;
    // setup timeline with christmas cards
    $37cee55efb58cc92$export$4c747dfc877cb40f();
    var container = $37cee55efb58cc92$export$2fa187e846a241c4(".timeline-container");
    var slides = $37cee55efb58cc92$export$dcd0d083aa86c355(".swiper-slide");
    // calculate original width-height ration and do the same for current height
    // if width would exceed 612px (default horizontal photo width for LR portraits), crop it to 612
    // it's required to force slide width with styling to avoid scropping slides at the end
    slides.forEach(function(slide) {
        var img = $37cee55efb58cc92$export$2fa187e846a241c4("img", slide);
        var originalW = parseInt(img.getAttribute("width"));
        var originalH = parseInt(img.getAttribute("height"));
        var newW = originalH > originalW ? "50%" : "100%";
        var newMaxW = originalH > originalW ? "300px" : "600px";
        slide.style.width = newW;
        slide.style.maxWidth = newMaxW;
        // add padding to avoid text cropping -- skip on desktop
        var resizeSlide = function() {
            if (slide.clientWidth < 200) slide.style.width = "200px";
            if (window.innerWidth > 768) {
                slide.style.width = newW;
                slide.style.padding = null;
                return;
            }
            slide.style.padding = "0 ".concat((slide.clientWidth - container.clientWidth) / 2, "px");
        };
        window.addEventListener("resize", resizeSlide);
        resizeSlide();
    });
};
var $37cee55efb58cc92$export$d96cf7a301413e59 = function() {
    var emailPlaceholders = $37cee55efb58cc92$export$dcd0d083aa86c355("[data-email-placeholder]");
    var encodeEmail = function(email) {
        return email.split("").map(function(letter) {
            return "&#".concat(letter.charCodeAt(), ";");
        }).join("");
    };
    emailPlaceholders === null || emailPlaceholders === void 0 ? void 0 : emailPlaceholders.forEach(function(el) {
        var email = el.dataset.emailPlaceholder;
        // prettier-ignore
        el.innerHTML = "<span>".concat(encodeEmail(email), "</span><span>").concat(encodeEmail("@"), "</span><span>").concat(encodeEmail("lassenricard.dk"), "</span>");
        if (!el.classList.contains("nolink")) el.href = "javascript:sendEmail('".concat(btoa(encodeEmail(email + "@lassenricard.dk")), "')");
    });
};
var $37cee55efb58cc92$export$b749c3fd2939ef3f = function() {
    var expandAllButtons = $37cee55efb58cc92$export$dcd0d083aa86c355(".accordion__expand-all");
    if (!expandAllButtons.length) return;
    expandAllButtons.forEach(function(button) {
        button.addEventListener("click", function() {
            button.classList.toggle("active");
            var shouldExpand = button.classList.contains("active");
            var accordionItems = $37cee55efb58cc92$export$dcd0d083aa86c355(".accordion-item", button.parentElement);
            accordionItems.forEach(function(item) {
                if (shouldExpand) item.classList.add("active");
                else item.classList.remove("active");
                var content = $37cee55efb58cc92$export$2fa187e846a241c4(".accordion-item__content", item);
                content.style.maxHeight = shouldExpand ? content.scrollHeight + "px" : "0px";
            });
            // finish if it was normal accordion
            if (accordionItems.length) return;
            // case for employee profile accordion
            var userAccordionItems = $37cee55efb58cc92$export$dcd0d083aa86c355(".accordion-user-profile");
            userAccordionItems.forEach(function(item) {
                return $37cee55efb58cc92$var$changeUserAccordionItem($37cee55efb58cc92$export$2fa187e846a241c4("button", item), shouldExpand);
            });
        });
    });
};
var $37cee55efb58cc92$var$changeUserAccordionItem = function(button) {
    var expand = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var cross = $37cee55efb58cc92$export$2fa187e846a241c4(".accordion-user-profile--cross", button);
    var content = button.nextElementSibling;
    var accordionContainer = button.parentElement.parentElement // employee-full__accordion-employee
    ;
    var expandAllButton = $37cee55efb58cc92$export$2fa187e846a241c4(".accordion__expand-all", accordionContainer);
    var allItems = $37cee55efb58cc92$export$dcd0d083aa86c355(".accordion-user-profile--cross", accordionContainer);
    if (expand == null) // if no expand argument was given just toggle
    cross.classList.toggle("active");
    else // otherwise override the class
    if (expand) cross.classList.add("active");
    else cross.classList.remove("active");
    if (cross.classList.contains("active")) {
        content.style.maxHeight = content.scrollHeight + "px";
        // check if all accordion items are opened and toggle "expand/collapse all" button
        var allOpened = allItems.every(function(item) {
            return item.classList.contains("active");
        });
        if (allOpened) expandAllButton.classList.add("active");
    } else {
        content.style.maxHeight = null;
        // check if all accordion items are closed and toggle "expand/collapse all" button
        var allClosed = allItems.every(function(item) {
            return !item.classList.contains("active");
        });
        if (allClosed) expandAllButton.classList.remove("active");
    }
};
var $37cee55efb58cc92$export$f64e55420d5a3dc0 = function() {
    var buttons = $37cee55efb58cc92$export$dcd0d083aa86c355(".accordion-user-profile__button");
    if (!buttons.length) return;
    buttons.forEach(function(button) {
        button.addEventListener("click", function() {
            return $37cee55efb58cc92$var$changeUserAccordionItem(button);
        });
    });
};
var $37cee55efb58cc92$export$b698643b2748997e = function() {
    var attachEvent = function() {
        var employees = $37cee55efb58cc92$export$dcd0d083aa86c355(".employee");
        if (employees.length === 0) return;
        var resize = function() {
            employees.forEach(function(e) {
                var photo = $37cee55efb58cc92$export$2fa187e846a241c4(".employee__photo", e);
                photo.style.height = e.offsetWidth * 1.2 + "px";
            });
        };
        window.addEventListener("resize", resize);
        resize();
    };
    // observer changes in body to detect filtering and re-rendering of node
    var observer = new MutationObserver(attachEvent);
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    attachEvent();
};
var $37cee55efb58cc92$export$33797193da6cf221 = function() {
    var menuItems = $37cee55efb58cc92$export$dcd0d083aa86c355('.menu__item[data-level="0"]');
    var positionItems = function(item) {
        var submenuItemsContainer = $37cee55efb58cc92$export$2fa187e846a241c4(".submenu__items", item);
        if (!submenuItemsContainer) return;
        var gap = parseInt(getComputedStyle(submenuItemsContainer).gap) // get container's flex gap
        ;
        var submenuItems = $37cee55efb58cc92$export$dcd0d083aa86c355("li", submenuItemsContainer) // get submenu items
        ;
        var startX = item.getBoundingClientRect().x + 10 // get parent element's X as starting point
        ;
        var contentWidth = -gap // compensate for 1 gap
        ;
        submenuItems.forEach(function(i) {
            return contentWidth += i.clientWidth + gap;
        }) // calculate content width from submenu items & gap
        ;
        // if content would overflow the window, reduce the padding by difference in width
        // prettier-ignore
        if (contentWidth + startX >= window.innerWidth - 50) {
            var newPadding = startX - (contentWidth + startX - (window.innerWidth - 50));
            submenuItemsContainer.style.paddingLeft = (newPadding > 0 ? newPadding : 5) + "px"; // avoid setting negative padding
        } else submenuItemsContainer.style.paddingLeft = startX + "px"; // otherwise set default padding
    };
    menuItems.forEach(function(item) {
        // position submenu items on hover & on load
        item.addEventListener("mouseenter", function() {
            return positionItems(item);
        });
        positionItems(item);
        // re-position submenu items on resize
        window.addEventListener("resize", function() {
            return positionItems(item);
        });
        // if any child is active, keep submenu open
        var submenuItems = $37cee55efb58cc92$export$2fa187e846a241c4(".submenu__items", item);
        if (submenuItems === null || submenuItems === void 0 ? void 0 : submenuItems.innerHTML.includes("is-active")) {
            item.classList.add("active-submenu");
            positionItems(item);
        }
    });
};
var $37cee55efb58cc92$export$5c6d2be0d59167a6 = function() {
    var title = $37cee55efb58cc92$export$2fa187e846a241c4(".node-title");
    var targetTitle = $37cee55efb58cc92$export$2fa187e846a241c4(".title--target");
    if (targetTitle) targetTitle.innerHTML = title.innerHTML;
};
var $37cee55efb58cc92$export$7120c31117304a49 = function() {
    // submenu extending
    $37cee55efb58cc92$export$dcd0d083aa86c355(".menu__expand-toggle").forEach(function(el) {
        el.addEventListener("click", function() {
            var parentList = el.parentElement.parentElement // .menu__item
            ;
            (0, $f2367938ccf27490$export$af52c964fce46aba)(parentList, !parentList.classList.contains("is-expanded"));
            parentList.classList.toggle("is-expanded");
            var wrapper = $37cee55efb58cc92$export$2fa187e846a241c4(".menu__wrapper");
            var menuItems = $37cee55efb58cc92$export$dcd0d083aa86c355(".menu__item");
            var isExpanded = menuItems.some(function(el) {
                return el.classList.contains("is-expanded");
            });
            if (isExpanded) wrapper.classList.add("submenu-expanded");
            else wrapper.classList.remove("submenu-expanded");
        });
    });
    // menu toggling on mobile
    $37cee55efb58cc92$export$2fa187e846a241c4(".menu__hamburger").addEventListener("click", function() {
        $37cee55efb58cc92$export$2fa187e846a241c4(".menu__wrapper").classList.toggle("expanded");
        $37cee55efb58cc92$export$2fa187e846a241c4("html").classList.toggle("no-scroll");
        var isExpanded = $37cee55efb58cc92$export$2fa187e846a241c4(".menu__wrapper").classList.contains("expanded");
        // collapsed every opened submenu on close
        if (!isExpanded) $37cee55efb58cc92$export$dcd0d083aa86c355(".menu__item").forEach(function(el) {
            if (el.classList.contains("is-expanded")) $37cee55efb58cc92$export$2fa187e846a241c4(".menu__expand-toggle", el).click() // needs to be done via .click() to properly remove inlined max-height
            ;
        });
        (0, $f2367938ccf27490$export$b3863211bcd5504f)(isExpanded);
    });
    // set active language preview on desktop
    var activeLang = $37cee55efb58cc92$export$2fa187e846a241c4(".menu__langs--desktop .language-link.is-active");
    $37cee55efb58cc92$export$2fa187e846a241c4(".menu__active-lang").innerHTML = activeLang.hreflang === "da" ? "dk" : activeLang.hreflang;
    // create a delay when mouse leaves the language container or menu item
    (0, $f2367938ccf27490$export$292af6cf5856552d)(".menu__langs-container", ".menu__langs", ".5s, .3s");
    $37cee55efb58cc92$export$dcd0d083aa86c355(".menu__items > .menu__item").forEach(function(el) {
        (0, $f2367938ccf27490$export$292af6cf5856552d)(el, $37cee55efb58cc92$export$2fa187e846a241c4(".submenu__items", el), ".3s, .1s");
        // force active submenu to the top
        var subItems = $37cee55efb58cc92$export$2fa187e846a241c4(".submenu__items", el);
        if (subItems) {
            el.addEventListener("mouseover", function() {
                return subItems.style.zIndex = 10;
            });
            el.addEventListener("mouseout", function() {
                return subItems.style.zIndex = 1;
            });
        }
    });
    // change language name to language code on mobile
    $37cee55efb58cc92$export$dcd0d083aa86c355(".menu__langs--mobile .language-link").forEach(function(lang) {
        var langCode = lang.hreflang;
        lang.innerHTML = langCode === "da" ? "dk" : langCode;
    });
};
var $37cee55efb58cc92$export$bae4cb43615190c9 = function() {
    var button = $37cee55efb58cc92$export$2fa187e846a241c4(".list__button");
    if (button) {
        var attachedList = $37cee55efb58cc92$export$2fa187e846a241c4(".items-list", button.parentElement);
        var elements = $37cee55efb58cc92$export$dcd0d083aa86c355("article", attachedList);
        // add class specifying list contains more than 'x' elements
        // to properly display rows and the "show more" button
        var counter = null;
        if (elements.length > 2) counter = 2;
        if (elements.length > 3) counter = 3;
        if (elements.length > 4) counter = 4;
        if (elements.length > 6) counter = 6;
        if (elements.length > 8) counter = 8;
        if (counter) attachedList.classList.add("list-".concat(counter, "-items"));
        button.addEventListener("click", function() {
            button.classList.toggle("toggled");
            attachedList.classList.toggle("expanded");
        });
    }
};
var $37cee55efb58cc92$export$49158ff61951a328 = function() {
    var setActiveElement = // underlines and darken active list element
    function setActiveElement(index) {
        $37cee55efb58cc92$export$2fa187e846a241c4(".plain__list-item.active").classList.remove("active") // remove class from currently active element
        ;
        listItems[index].classList.add("active") // add class to clicked element
        ;
    };
    var _query;
    // check if page has "content with menu" paragraph
    var sections = $37cee55efb58cc92$export$dcd0d083aa86c355(".plain__content-section.menu-item");
    if (sections.length === 0) return;
    // add menu items based on h3
    sections.forEach(function(section) {
        var header = $37cee55efb58cc92$export$2fa187e846a241c4("h3", section).innerText;
        if (header) {
            var _query;
            var newLi = document.createElement("li");
            newLi.className = "plain__list-item";
            newLi.innerHTML = '<a href="#'.concat(section.id, '">').concat(header, "</a>");
            (_query = $37cee55efb58cc92$export$2fa187e846a241c4(".plain__list")) === null || _query === void 0 ? void 0 : _query.appendChild(newLi);
        }
    });
    (_query = $37cee55efb58cc92$export$2fa187e846a241c4(".plain__list-item")) === null || _query === void 0 ? void 0 : _query.classList.add("active") // set first menu element as active
    ;
    // adds click events for list items
    var listItems = $37cee55efb58cc92$export$dcd0d083aa86c355(".plain__list-item");
    listItems.forEach(function(item) {
        item.addEventListener("click", function() {
            setActiveElement(listItems.indexOf(item));
        });
    });
    // adds scrolling-activation behavior
    sections.forEach(function(section) {
        new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) setActiveElement(sections.indexOf(section));
            });
        }, {
            rootMargin: "-40% 0px -60% 0px",
            threshold: 0
        }).observe(section);
    });
};
var $37cee55efb58cc92$export$203d47965cdbdecb = function() {
    var buttons = $37cee55efb58cc92$export$dcd0d083aa86c355(".accordion-item__title");
    if (buttons.length === 0) return;
    buttons.forEach(function(button) {
        button.addEventListener("click", function() {
            var accordionItem = button.parentElement;
            var accordionContainer = accordionItem.parentElement;
            var contentElement = $37cee55efb58cc92$export$2fa187e846a241c4(".accordion-item__content", accordionItem);
            var allItems = $37cee55efb58cc92$export$dcd0d083aa86c355(".accordion-item", accordionContainer);
            var expandAllButton = $37cee55efb58cc92$export$2fa187e846a241c4(".accordion__expand-all", accordionContainer);
            accordionItem.classList.toggle("active");
            if (accordionItem.classList.contains("active")) {
                contentElement.style.maxHeight = contentElement.scrollHeight + "px";
                // check if all accordion items are opened and toggle "expand/collapse all" button
                var allOpened = allItems.every(function(item) {
                    return item.classList.contains("active");
                });
                if (allOpened) expandAllButton.classList.add("active");
            } else {
                contentElement.style.maxHeight = "0px";
                // check if all accordion items are closed and toggle "expand/collapse all" button
                var allClosed = allItems.every(function(item) {
                    return !item.classList.contains("active");
                });
                if (allClosed) expandAllButton.classList.remove("active");
            }
        });
    });
};


(function() {
    Drupal.behaviors.betterExposedFilters = {
        attach: function attach() {
            // hardcoded footer node id
            var footerArticles = (0, $37cee55efb58cc92$export$dcd0d083aa86c355)('article[data-history-node-id="31"]');
            if (footerArticles.length > 1) footerArticles[0].remove();
        }
    };
})();

})();
//# sourceMappingURL=views-ajax.js.map
